<svg width="10px" height="6px" viewBox="0 0 10 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g id="Subgroup" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Device-Hover" transform="translate(-459.000000, -129.000000)">
      <g id="Dropdown-list-w-Checkboxes" transform="translate(360.000000, 116.000000)">
        <g id="subgroup">
          <g id="subgroup_default">
            <g id="chevron_down_16" transform="translate(96.000000, 8.000000)">
              <g>
                <rect id="Rectangle-12" x="0" y="0" width="16" height="16"></rect>
                <polygon id="Path-10" [attr.fill]="color" points="3 5 4.5 5 8 9 11.5 5 13 5 8 11"></polygon>
                <polygon id="Path-10" [attr.fill]="color" points="3 5 4.5 5 8 9 11.5 5 13 5 8 11"></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>